import { connect } from 'react-redux'
import component from './component'
import { fetchSendEmailShoppingList } from '../../../../components/EmailSubscriptionForm/actions/data'
import { setEmailAddress } from 'components/EmailSubscriptionForm/actions'


const mapStateToProps = state => ({
    ...state.emailSubscriptionForm,
    language: state.app.language,
    isCaptchaPassed: !!state.appCaptcha.token
})

export default connect(
    mapStateToProps,
    {
        setEmailAddress,
        fetchSendEmailShoppingList
    }
)(component)
